/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 */

import { apiSlice } from "../Slices/apiSlice";

export const customerService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Lookup customers by mobile number or email address.
    // Always returns an array (0, 1, or many matching records).
    lookupCustomer: builder.query({
      query: (search) =>
        `/customer-management/managed-customer/search?search=${encodeURIComponent(
          search
        )}`,
      transformResponse: (response) => {
        const data = response?.data ?? response ?? [];
        return Array.isArray(data) ? data : data ? [data] : [];
      },
      providesTags: ["customer"],
    }),

    getCustomerById: builder.query({
      query: (customerId) =>
        `/customer-management/managed-customer/${customerId}`,
      transformResponse: (response) => response?.data ?? response ?? null,
      providesTags: ["customer"],
    }),

    createCustomer: builder.mutation({
      query: (customerDetails) => ({
        url: "/customer-management/managed-customer",
        method: "POST",
        body: customerDetails,
      }),
      transformResponse: (response) => response?.data ?? response ?? null,
      invalidatesTags: ["customer"],
    }),

    updateCustomer: builder.mutation({
      query: (customerDetails) => ({
        url: "/customer-management/managed-customer",
        method: "PUT",
        body: customerDetails,
      }),
      transformResponse: (response) => response?.data ?? response ?? null,
      invalidatesTags: ["customer"],
    }),
  }),
});

export const {
  useLazyLookupCustomerQuery,
  useGetCustomerByIdQuery,
  useCreateCustomerMutation,
  useUpdateCustomerMutation,
} = customerService;
